module.exports = __webpack_public_path__ + "static/media/CTLI_10-315w.cc143198.jpg";